// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Karla:400,700);"]);
// Module
exports.push([module.id, ".image {\n  border: 1px solid #ccc;\n  border-radius: 8px;\n}\n#templateList .btn {\n  border-radius: 4px;\n}", ""]);
// Exports
module.exports = exports;
